module.exports = "<div style=\"position: relative\"> <fixed-action-button icon=edit :horizontal=true :click-only=true style=\"position: absolute; display: inline-block; right: 24px\"> <ul> <li><btn type=floating class=red icon=edit></btn></li> <li><btn type=floating class=yellow icon=edit></btn></li> <li><btn type=floating class=green icon=edit></btn></li> <li><btn type=floating class=blue icon=edit></btn></li> </ul> </fixed-action-button> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../src/demos/buttons/click-only-fab.vue
 ** module id = 159
 ** module chunks = 0
 **/